import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
let MobileMenu = class MobileMenu extends Vue {
    showMenu() {
        window.eventBus.$emit('toggleMobileMenu');
    }
};
MobileMenu = __decorate([
    Component({
        data() {
            return {};
        },
        props: ['hideMenu'],
    })
], MobileMenu);
export default MobileMenu;
